import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/data/site";
import { SectionHead, FadeUp } from "@/components/site/Reveal";

export const Faq = () => (
  <section className="relative py-24 md:py-36" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-6 md:px-10">
      <SectionHead
        label="Questions fréquentes"
        title={
          <>
            Vos dernières <span className="text-gradient">questions.</span>
          </>
        }
      />
      <FadeUp>
        <Accordion type="single" collapsible className="flex flex-col gap-3">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="card-surface rounded-2xl px-6 border-b-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display font-bold text-base md:text-lg hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[var(--text-secondary)] text-sm md:text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </FadeUp>
    </div>
  </section>
);

export default Faq;
